import { BrowserRouter, Routes, Route } from "react-router-dom";
import React from "react";
import InitialPage from "./pages/InitialPage";
import Projects from "./pages/Projects";
import CustomCursor from "./components/customCursor";
import { Analytics as VercelAnalytics } from "@vercel/analytics/react"

function App() {
	return (
    <BrowserRouter>
      <CustomCursor/>
      <Routes>
        <Route path="/" element={<InitialPage/>} />
        <Route path="/projects" element={<Projects/>} />
      </Routes>
      <VercelAnalytics />
    </BrowserRouter>

  )
};

export default App;